class ColorSwatch extends HTMLElement {
    constructor() {
        super();

        this.cached = {};
        this.variantId = this.dataset.variantId;
        this.container = this.closest(".mm-product-card");
        this.pack = this.container.dataset.pack;
        this.CTA_OPEN = this.container.querySelector('.mm-product-card-button-open-cart');
        this.CTA_NOT_OPEN = this.container.querySelector('.mm-product-card-button-not-open-cart');

        if (this.variantId) {
            this.addEventListener("click", this.onHoverHandler.bind(this));
        } else {
            this.addEventListener("click", this.onHoverHandler.bind(this));
        }
    }

    onHoverHandler() {
        this.container.querySelector(".mm-product-card-colors-container").classList.add("loading");
        if (this.variantId) {
            this.colorSwatchFetch();
        } else {
            this.colorSwatchChange();
        }
    }

    colorSwatchChange(forceUpdate) {
        const image = this.container.querySelector(".mm-product-card_image-main");
        const imagePack = this.container.querySelector(".mm-product-card-pack_image");
        const imageHover = this.container.querySelector(".mm-product-card_image--hover");

        if (image !== null || forceUpdate) {
            if (image !== null) {
                image.src = this.dataset.imageSrc;
                image.srcset = this.dataset.imageSrc;
            }
        }

		if (imagePack != null || forceUpdate) {
            if (imagePack !== null) {
                imagePack.src = this.dataset.imagePackSrc;
                imagePack.srcset = this.dataset.imagePackSrc;
            }
        }
		
        if (imageHover != null || forceUpdate) {
            if (imageHover !== null) {
                imageHover.src = this.dataset.imageHoverSrc;
                imageHover.srcset = this.dataset.imageHoverSrc;
            }
        }

        const swatches = this.container.querySelectorAll(".mm-product-card-color-swatch");
        swatches.forEach((swatch) => {
            swatch.classList.remove("is-active");
        });

        this.classList.add("is-active");
    }

    colorSwatchFetch() {
        const productHandle = this.dataset.productHandle;
        let sectionUrl = `/products/${productHandle}?variant=${this.variantId}&view=card`;

        // remove double `/` in case shop might have /en or language in URL
        sectionUrl = sectionUrl.replace("//", "/");

        if (this.cached[sectionUrl]) {
            this.renderProductInfo(this.cached[sectionUrl]);
            return;
        }

        fetch(sectionUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.cached[sectionUrl] = html;
                this.renderProductInfo(html);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderProductInfo(html) {
        this.colorSwatchChange(true);
        this.updateElement(".mm-product-card-title", html);
        this.updateElement(".mm-product-card-price", html);
        this.updateElementOuter(".mm-product-card-button-container", html);
        this.updateElementOuter(".mm-product-card-variant_id", html);
        this.updateSwym(".mm-swym-button",html);
        this.removeLoading();
		this.checkPack();
    }
    /**
     *
     * @param {string} selector
     * @param {HtmlElement} html
     */
    updateElement(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.innerHTML = source.innerHTML;
    }

    updateElementOuter(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.outerHTML = source.outerHTML;
    }

    updateSwym(selector, html, info){
        const destination = this.container.querySelector(selector);
        destination.classList.add('swym-loaded')
    }

    removeLoading() {
        this.container.querySelector(".mm-product-card-colors-container").classList.remove("loading");
    }

	checkPack() {
        const new_open_cta = this.container.querySelector('.mm-product-card-button-open-cart');
        const new_not_open_cta = this.container.querySelector('.mm-product-card-button-not-open-cart');

		if (window.innerWidth > 768) {
			if (this.pack == 'true') {
				new_open_cta.classList.add('mm-none');
				new_not_open_cta.classList.remove('mm-none');
			} else {
				new_not_open_cta.classList.add('mm-none');
				new_open_cta.classList.remove('mm-none');
			}
		}
	}
}
customElements.define("color-swatch", ColorSwatch);

class ColorSwatchRadios extends HTMLElement {
    constructor() {
        super();
        this.cached = {};
        this.container = this.closest(".mm-product-card");
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();

        if (this.currentVariant) {
            this.updateCTA();
            this.updatePrice();
            this.updateVariantIdSwym();
            this.updateFormID();
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll(".mm-product-card-variant-checkbox:checked"), (checkbox) => checkbox.value);
    }

    getVariantJSON() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find((variant) => {
            const findings = !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
            if (findings) return variant;
        });
    }

    updateFormID() {
        const form_input = this.querySelector(".mm-product-card-variant_id");
        form_input.value = this.currentVariant.id;
    }
	
    updateVariantIdSwym(){
        this.container.querySelector(".mm-swym-button").dataset.variantId = this.currentVariant.id;
    }

    updateCTA() {
        const CTA = document.querySelector(".mm-product-card-button");
        if (this.currentVariant.available) {
            CTA.classList.remove("mm-btn-disabled");
        } else {
            CTA.classList.add("mm-btn-disabled");
        }
    }

    updatePrice() {
		const comparePrice = this.container.querySelector(".mm-product-card-price .mm-compared-price-product");
		const price = this.container.querySelector(".mm-product-card-price .mm-price-product");
		
		// Accéder au prix et au prix comparé de la variante actuelle
		let formattedPrice = (this.currentVariant.price / 100).toFixed(2);
		let formattedComparedPrice = this.currentVariant.compare_at_price ? (this.currentVariant.compare_at_price / 100).toFixed(2) : null;
	
		// Vérifiez si le prix a des décimales autres que "00"
		if (formattedPrice.endsWith("00")) {
			// Si oui, on enlève la partie décimale pour le prix principal
			formattedPrice = Math.round(this.currentVariant.price / 100).toString();
		} else {
			// Sinon, on remplace le point par une virgule pour les décimales
			formattedPrice = formattedPrice.replace(".", ",");
		}
	
		// Même chose pour le prix comparé, si disponible
		if (formattedComparedPrice && formattedComparedPrice.endsWith("00")) {
			formattedComparedPrice = Math.round(this.currentVariant.compare_at_price / 100).toString();
		} else if (formattedComparedPrice) {
			formattedComparedPrice = formattedComparedPrice.replace(".", ",");
		}
	
		// Mettre à jour l'affichage du prix principal
		price.innerText = formattedPrice + " €";
	
		// Mettre à jour l'affichage du prix comparé, si l'élément existe
		if (comparePrice && formattedComparedPrice) {
			comparePrice.innerText = formattedComparedPrice + " €";
		}
	}
	
}
customElements.define("color-swatch-radios", ColorSwatchRadios);

function displayButtonMobile(target, withSplide) {
    var buttonContainer = document.querySelector(target);
    if (buttonContainer.style.opacity == 0) {
        buttonContainer.style.opacity = 1;
        buttonContainer.style.display = "flex";
        document.querySelector("html").classList.add("stop-scrolling");
        if (withSplide) {
            var containerSplide = buttonContainer.closest(".splide__track");
            containerSplide.classList.add("mm-splide-fixed");
        }
    } else {
        buttonContainer.style.opacity = 0;
        buttonContainer.style.display = "none";
        document.querySelector("html").classList.remove("stop-scrolling");
        if (withSplide) {
            var containerSplide = buttonContainer.closest(".splide__track");
            containerSplide.classList.remove("mm-splide-fixed");
        }
    }
}
